import { Rive } from '@rive-app/canvas';

const COPY_DELAY = 1750;

/**
 * FVセクションのRiveアニメーション制御
 */
export class FVRive {
  private _copyRive: Rive | null = null;
  private _copyCanvas: HTMLCanvasElement | null = null;
  private _isInitialLoad = true;

  constructor() {
    this._initBgRive();
    this._initCopyRive();
  }

  /** 背景Riveの初期化 */
  private _initBgRive(): void {
    const bgCanvas = document.getElementById('fv__image__rive-bg') as HTMLCanvasElement | null;
    if (!bgCanvas?.dataset.src) return;

    const bgRive = new Rive({
      canvas: bgCanvas,
      src: bgCanvas.dataset.src,
      autoplay: true,
      stateMachines: "State Machine 1",
      onLoad: () => {
        bgRive.resizeDrawingSurfaceToCanvas();
      },
    });
  }

  /** コピーRiveの初期化（PC/SP切り替え対応） */
  private _initCopyRive(): void {
    this._copyCanvas = document.getElementById('fv__copy__rive-copy') as HTMLCanvasElement | null;
    if (!this._copyCanvas) return;

    const mql = window.matchMedia('(max-width: 480px)');

    // 初期読み込み
    this._loadCopyRive(mql.matches);

    // リサイズ時の切り替え
    mql.addEventListener('change', (e) => {
      this._loadCopyRive(e.matches);
    });
  }

  /** コピーRiveの読み込み・切り替え */
  private _loadCopyRive(isSp: boolean): void {
    // 既存インスタンスを破棄
    if (this._copyRive) {
      this._copyRive.cleanup();
      this._copyRive = null;
    }

    const src = isSp ? this._copyCanvas!.dataset.srcSp : this._copyCanvas!.dataset.srcPc;
    if (!src) return;

    this._copyRive = new Rive({
      canvas: this._copyCanvas!,
      src,
      autoplay: false,
      onLoad: () => {
        this._copyRive!.resizeDrawingSurfaceToCanvas();

        if (this._isInitialLoad) {
          // 初期読み込み: 遅延再生
          this._isInitialLoad = false;
          setTimeout(() => this._copyRive!.play(), COPY_DELAY);
        } else {
          // 切り替え時: 即再生
          this._copyRive!.play();
        }
      },
    });
  }
}
